import type { BundleContext } from './BundleContext.js';
import type { BundleOptions } from './BundleOptions.js';
import type { BundlerPluginResult } from './BundleResult.js';

export interface BundlerPlugin {
  name: string;
  bundle: (options: BundleOptions, context: BundleContext) => Promise<BundlerPluginResult>;
}
